import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { mapGptEventEngineOffGeoJsonState } from '../../../storage/gpt';
import GptEventEngineOffMarker from './GptEventEngineOffMarker';

function GptEventEngineOffMarkers() {
  const geojson = useRecoilValue(mapGptEventEngineOffGeoJsonState);

  return (
    <>
      {geojson.map((feature, index) => {
        const { properties } = feature;
        const alarm = properties?.alarm;
        if (alarm) {
          return <GptEventEngineOffMarker key={index} engineOffEvents={alarm} />;
        }
        return null;
      })}
    </>
  );
}

export default memo(GptEventEngineOffMarkers);
